import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["apsKey"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { FlightDeckClient } from '@atlassiansox/flight-deck-frontend-client';
import { createProviderWithCustomFetchData } from './create-data-provider';
import { ExperienceMark } from '../utils/experience-tracker/constants';
import { formatDescription, formatLabel } from './product-configuration-provider';
import { isFedRamp } from '@atlassian/atl-context';
import { ASSETS_APP_KEY } from '../../constants';
import messages from '../utils/messages';
var client = new FlightDeckClient('atlassian-switcher', {
  handlers: {},
  // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
  // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
  // https://hello.jira.atlassian.cloud/browse/NAVX-658
  //@ts-ignore
  storageEngine: 'sessionStorage'
});
var _createProviderWithCu = createProviderWithCustomFetchData('flightDeck', ExperienceMark.API_FLIGHT_DECK, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var artifact;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return client.fetchConfigFromFlightDeck({
            name: 'app-switcher-fe',
            dimensions: {
              environmentType: 'prod',
              perimeter: isFedRamp() ? 'fedramp-moderate' : 'commercial'
            }
          });
        case 2:
          artifact = _context.sent;
          return _context.abrupt("return", transformFlightDeckArtifactToProductConfiguration(artifact));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))),
  fetchFlightDeck = _createProviderWithCu.fetchMethod,
  DefaultFlightDeckProviderComponent = _createProviderWithCu.ProviderComponent;
var transformFlightDeckArtifactToProductConfiguration = function transformFlightDeckArtifactToProductConfiguration(artifact) {
  var artifactMap = new Map();
  var _iterator = _createForOfIteratorHelper(artifact.products),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;
      var apsKey = product.apsKey,
        tcsProductKey = product.tcsProductKey,
        siteUrlSuffix = product.siteUrlSuffix,
        displayName = product.displayName,
        rebrandedDisplayName = product.rebrandedDisplayName,
        subtitle = product.subtitle,
        ordinal = product.ordinal,
        iconKey = product.iconKey,
        rebrandedIconKey = product.rebrandedIconKey;
      artifactMap.set(apsKey, {
        key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
        href: siteUrlSuffix,
        ordinal: ordinal,
        label: formatLabel(displayName),
        rebrandedLabel: rebrandedDisplayName && formatLabel(rebrandedDisplayName),
        description: formatDescription(subtitle),
        iconKey: iconKey,
        rebrandedIconKey: rebrandedIconKey
      });
      // TODO: remove this once Asset app becomes standalone app
      if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has(ASSETS_APP_KEY)) {
        artifactMap.set(ASSETS_APP_KEY, {
          key: ASSETS_APP_KEY,
          href: '/jira/assets',
          ordinal: ordinal + 0.1,
          // make sure assets is below jsm
          label: formatLabel(messages.assets),
          iconKey: 'assets'
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return {
    products: Object.fromEntries(artifactMap),
    links: Object.fromEntries(artifact.links.map(function (_ref2) {
      var apsKey = _ref2.apsKey,
        link = _objectWithoutProperties(_ref2, _excluded);
      return [apsKey, _objectSpread(_objectSpread({}, link), {}, {
        key: apsKey.toLowerCase(),
        href: link.url,
        label: formatLabel(link.displayName),
        description: formatDescription(link.subtitle),
        iconKey: 'admin'
      })];
    }))
  };
};
export var FlightDeckProvider = function FlightDeckProvider(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(DefaultFlightDeckProviderComponent, null, children);
};
export var prefetchFlightDeck = fetchFlightDeck;